import {
  QueryRequestContextProps,
  initialQueryRequest,
  WithChildren,
  QueryState,
} from '_metronic/helpers'
import { FC, useState, createContext, useContext, useCallback } from 'react'
import { useParams } from 'react-router-dom'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const { id } = useParams<{ id: string }>()

  // Só os registros do usuário da rota, mais recentes primeiro.
  const [state, setState] = useState<QueryState>({
    ...initialQueryRequest.state,
    search: `usuario.id:${id}`,
    fixedSort: [{ field: 'data', order: 'desc' }],
  })

  const updateState = useCallback(
    (updates: Partial<QueryState>) =>
      setState((prev) => ({
        ...prev,
        ...updates,
      })),
    []
  )

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

export const useQueryRequest = () => useContext(QueryRequestContext)
